import * as Yup from "yup";

export const llmModelOptions = {
  openai: [
    { value: "gpt-5.4",       label: "GPT-5.4" },
    { value: "gpt-5.4-mini",  label: "GPT-5.4 Mini" },
    { value: "gpt-5.2",       label: "GPT-5.2 Thinking" },
    { value: "gpt-5",         label: "GPT-5" },
  ],

  anthropic: [
    { value: "claude-opus-4-6",            label: "Claude Opus 4.6" },
    { value: "claude-sonnet-4-6",          label: "Claude Sonnet 4.6" },
    { value: "claude-sonnet-4-5", label: "Claude Sonnet 4.5" },
  ],

  groq: [
    { value: "openai/gpt-oss-120b", label: "GPT OSS 120B" },
  ],

  deepseek: [
    { value: "deepseek-chat",     label: "DeepSeek V3 (Chat)" },
    { value: "deepseek-reasoner", label: "DeepSeek R1 (Reasoning)" },
  ],
};

export const transcriberOptions = {
  chat: [
    { value: "nova-3-general", label: "Nova-3 (General)" },
    { value: "nova-3-medical", label: "Nova-3 (Medical)" },
    { value: "nova-2-general", label: "Nova-2 (General)" },
    { value: "nova-2-phonecall", label: "Nova-2 (Phone Call)" },
    { value: "nova-general", label: "Nova (General)" },
    { value: "nova-phonecall", label: "Nova (Phone Call)" },
    { value: "enhanced", label: "Enhanced" },
    { value: "enhanced-phonecall", label: "Enhanced (Phone Call)" },
  ],
};

export const voiceOptions = {
  chat: [
    {
      value: "aura-2-thalia-en",
      label: "Thalia (Aura-2, US English, Feminine)",
    },
    {
      value: "aura-2-andromeda-en",
      label: "Andromeda (Aura-2, US English, Feminine)",
    },
    {
      value: "aura-2-helena-en",
      label: "Helena (Aura-2, US English, Feminine)",
    },
    {
      value: "aura-2-apollo-en",
      label: "Apollo (Aura-2, US English, Masculine)",
    },
    {
      value: "aura-2-arcas-en",
      label: "Arcas (Aura-2, US English, Masculine)",
    },
    {
      value: "aura-2-aries-en",
      label: "Aries (Aura-2, US English, Masculine)",
    },
    {
      value: "aura-2-amalthea-en",
      label: "Amalthea (Aura-2, Filipino English, Feminine)",
    },
  ],
};

export const llmvalidationSchema = Yup.object({
  model: Yup.string().required("AI model is required."),
  provider: Yup.string().required("Provider is required."),
});

export const llminitialValues = {
  model: "",
  provider: "",
  temperature: 0,
  topP: 0,
};

export const platformllmModelOptions = {
  google: [
    { value: "gemini-2.0-flash", label: "Gemini 2.0 Flash" },
    { value: "gemini-2.0-flash-lite", label: "Gemini 2.0 Flash Lite" },
    { value: "gemini-2.5-flash-lite", label: "Gemini 2.5 Flash Lite" },
    { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
  ],
  openai: [
    { value: "gpt-5", label: "GPT-5" },
    { value: "gpt-5-mini", label: "GPT-5 Mini" },
    { value: "gpt-5-nano", label: "GPT-5 Nano" },
    { value: "gpt-4.1", label: "GPT-4.1" },
    { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
    { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" },
    { value: "gpt-4o", label: "GPT-4o" },
    { value: "gpt-4o-mini", label: "GPT-4o Mini" },
    { value: "gpt-4-turbo", label: "GPT-4 Turbo" },
    { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo" },
  ],
  anthropic: [
    { value: "claude-sonnet-4", label: "Claude Sonnet 4" },
    { value: "claude-3-7-sonnet", label: "Claude 3.7 Sonnet" },
    { value: "claude-3-5-sonnet", label: "Claude 3.5 Sonnet" },
    { value: "claude-3-haiku", label: "Claude 3 Haiku" },
  ],
};

export const modelAgentTypes = {
  platform: "platform",
  question: "question",
};

export const configurationInitialValues = {
  name: "",
  type: "",
  llmProvider: "",
  llmModel: "",
  temperature: 0.0,
  modelId: "",
  voiceId: "",
  speed: 1,
  agentOutputAudioFormat: "",
  userInputAudioFormat: "",
};

export const configurationValidationSchema = Yup.object({
  name: Yup.string().required("Configuration name is required."),
  type: Yup.string().required("Type is required."),
  llmProvider: Yup.string().required("LLM provider is required."),
  llmModel: Yup.string().required("LLM model is required."),
  temperature: Yup.number().required("Temperature is required."),
  modelId: Yup.string().when("type", {
    is: (type) => type === "voice",
    then: (schema) => schema.required("Model ID is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  speed: Yup.number().when("type", {
    is: (type) => type === "voice",
    then: (schema) => schema.required("Speed is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  agentOutputAudioFormat: Yup.string().when("type", {
    is: (type) => type === "voice",
    then: (schema) => schema.required("Agent output audio format is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  userInputAudioFormat: Yup.string().when("type", {
    is: (type) => type === "voice",
    then: (schema) => schema.required("User input audio format is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const chatValidationSchema = Yup.object({
  name: Yup.string().required("Name is requried."),
  type: Yup.string().required("Type is requried"),
});

export const REASONING_SUPPORTED_MODELS = [
  "gpt-5",
  "gpt-5-mini",
  "gpt-5-nano",
  "claude-sonnet-4-5",
  "claude-3-7-sonnet",
];

export const REASONING_EFFORT_OPTIONS = [
  { value: "minimal", label: "Minimal" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const TRNASCRIBER_SUPPORTED_MODELS = [
  "scribe_v1",
  "whisper-1",
  "gpt-4o-transcribe",
  "gpt-4o-mini-transcribe",
  "gpt-4o-transcribe-diarize",
];

export const providerLabels = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  groq: "Groq",
  deepseek: "Deepseek"
};
